module.exports = __webpack_public_path__ + "img/idcard_f3x.58463085.png";